export default function SetupDeleteAccountSurvey() {
  const surveyOptions = [
    "I didn’t find useful Applets",
    "IFTTT didn’t work reliably",
    "I don’t want to give IFTTT access to my services",
    "Other",
  ]

  document.querySelectorAll(".item").forEach((el, idx) => {
    el.addEventListener("click", e => {
      document.getElementById("response_code").value = surveyOptions[idx]

      document.querySelectorAll(".item-content").forEach(el => {
        el.classList.add("hidden")
      })

      el.querySelectorAll(".item-content")[0].classList.remove("hidden")
    })

    el.querySelector("textarea:first-of-type").addEventListener("input", e => {
      document.getElementById("response_text").value = e.target.value
    })
  })
}
